module.exports = __webpack_public_path__ + "img/96.72d599aa.jpg";